var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cart"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cart",
    clipPath: "url(#clip-Cart)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8991",
    "data-name": "Group 8991",
    transform: "translate(0.949 1.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M15.564,54.123l2.249-7.483a.749.749,0,0,0-.718-.963H5.849v1.5H16.088l-.67,2.229H7.348v1.5h7.62l-.68,2.261H5.664L2.821,43.226a.75.75,0,0,0-.715-.543l-2.249-.016-.011,1.5,1.688.012,2.845,9.938a.749.749,0,0,0,.582.529H14.985A.749.749,0,0,0,15.564,54.123Z",
    transform: "translate(0.155 -42.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.808,
    cy: 1.808,
    r: 1.808,
    transform: "translate(5.326 12.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1.808,
    cy: 1.808,
    r: 1.808,
    transform: "translate(11.61 12.536)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.cb4ed381bd47f251a48d86dc80a79b95.svg";
export { ForwardRef as ReactComponent };